import { call, put } from 'redux-saga/effects'
import API from '../api/api'
import { statusCodeIsBelow400 } from '../helpers/utility'
import { watch } from './sagaUtils'
import { noop } from 'redux-saga/utils'
import {
  FETCH_SERVICE_DATA_ASYNC_END,
  FETCH_SERVICE_DATA_SUCCESS,
  FETCH_SERVICE_DATA_FAIL,
  FETCH_SERVICE_DATA_ASYNC_START,
  FETCH_SERVICE_DATA_REQUEST,
} from '../actions/actions'

function* getServiceData({ serviceCode, resolve = noop, reject = noop }) {
  try {
    yield put({ type: FETCH_SERVICE_DATA_ASYNC_START })
    const res = yield call(API.getService, serviceCode)

    if (!statusCodeIsBelow400(res.status)) {
      yield put({ type: FETCH_SERVICE_DATA_FAIL, error: res.errors })
      reject(res.errors)
      return
    }

    yield put({ type: FETCH_SERVICE_DATA_SUCCESS, service: res.data })
    resolve(res.data)
  } catch (error) {
    yield put({ type: FETCH_SERVICE_DATA_FAIL, error })
  } finally {
    yield put({ type: FETCH_SERVICE_DATA_ASYNC_END })
  }
}

export const fetchServiceData = watch(FETCH_SERVICE_DATA_REQUEST, getServiceData)



// WEBPACK FOOTER //
// ./src/sagas/servicesSaga.js